export const MIN_DRAWER_HEIGHT = 40;

// CSS variable published on :root to expose the current draggable drawer height
export const APP_DRAGGABLE_DRAWER_HEIGHT_VAR = '--app-draggable-drawer-height';

// When true, the popout window closes automatically on route changes and app unmount.
// Set to false to keep the popout open until the user explicitly closes it.
export const CLOSE_POPOUT_ON_NAVIGATION = true;

// Event used to request opening/focusing the drawer popout from other UI areas.
export const DRAWER_REOPEN_POPOUT_EVENT = 'drawer-reopen-popout';

// Transient handoff payloads expire quickly to avoid stale UI actions.
export const DRAWER_POPOUT_HANDOFF_TTL_MS = 30000;
